import React from 'react';
import './TrustBar.css';

function TrustBar() {
  const technologies = [
    { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg', description: 'Amazon Web Services' },
    { name: 'Google Cloud', logo: 'https://www.marefa.org/w/images/thumb/5/51/Google_Cloud_logo.svg/640px-Google_Cloud_logo.svg.png', description: 'Google Cloud Platform' },
    { name: 'React', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg', description: 'React' },
    { name: 'Laravel', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg', description: 'Laravel' },
    { name: 'Flutter', logo: 'https://storage.googleapis.com/cms-storage-bucket/0dbfcc7a59cd1cf16282.png', description: 'Flutter' },
    { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg', description: 'Microsoft' },
  ];


  return (
    <section className="trust-bar">
      <div className="trust-bar-overflow">
        <div className="trust-bar-track">
          {technologies.map((tech, index) => (
            <div key={index} className="trust-bar-item">
              <img src={tech.logo} alt={tech.name} className="trust-bar-logo" title={`${tech.name}: ${tech.description}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustBar;
